import { useContext } from 'react';
import { QuotesContext } from '../context/QuotesContextObject';

export const useQuotes = () => {
  const context = useContext(QuotesContext);
  if (!context) {
    throw new Error('useQuotes must be used within a QuotesDataProvider');
  }

  return context;
};
